import React, { useEffect, useRef, useState } from "react";
import { EllipsisVertical, Pencil, Trash2 } from "lucide-react";

import "./GroupCard.css";

const GroupCard = ({
  group,
  onOpen,
  onEdit,
  onDelete,
  canManage = false,
  deleting = false,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;

    const handleOutside = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
      }
    };

    document.addEventListener("pointerdown", handleOutside);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("pointerdown", handleOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [menuOpen]);

  const active =
    String(group.groupStatus || "")
      .trim()
      .toLowerCase() === "active";

  return (
    <article className="creator-group-card">
      <button
        type="button"
        className="creator-group-card__main"
        onClick={() => onOpen(group)}
        disabled={!active || deleting}
      >
        <strong className="creator-group-card__name">{group.groupName}</strong>

        <span className="creator-group-card__code">{group.groupCode}</span>

        <span className="creator-group-card__status">
          {group.groupStatus || "Unknown"}
        </span>
      </button>

      {canManage && (
        <div className="creator-group-card__menu-wrap" ref={menuRef}>
          <button
            type="button"
            className="creator-group-card__menu-toggle"
            aria-label={`Manage ${group.groupName}`}
            aria-haspopup="menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
            disabled={deleting}
          >
            <EllipsisVertical size={19} />
          </button>

          {menuOpen && (
            <div className="creator-group-card__menu" role="menu">
              <button
                type="button"
                role="menuitem"
                disabled={!onEdit}
                onClick={() => {
                  setMenuOpen(false);
                  onEdit?.(group);
                }}
              >
                <Pencil size={16} />
                Edit group
              </button>

              <button
                type="button"
                role="menuitem"
                className="creator-group-card__delete"
                disabled={!onDelete}
                onClick={() => {
                  setMenuOpen(false);
                  onDelete?.(group);
                }}
              >
                <Trash2 size={16} />
                {deleting ? "Deleting..." : "Delete group"}
              </button>
            </div>
          )}
        </div>
      )}
    </article>
  );
};

export default GroupCard;
